import React, { useState } from "react";
import PropTypes from "prop-types";
import { Outlet, Link, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import {
  AppBar,
  Box,
  CssBaseline,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Modal,
} from "@mui/material";

import Logo from "../../static/img/logo.png";
import { HiOutlineChartBar } from "react-icons/hi";
import { VscCircleLarge } from "react-icons/vsc";
import { BsCoin, BsCameraVideo } from "react-icons/bs";
import { IoCopyOutline } from "react-icons/io5";
import { TbCannabis } from "react-icons/tb";

import AccountCircle from "@mui/icons-material/AccountCircle";
import MenuIcon from "@mui/icons-material/Menu";
import LogoutIcon from "@mui/icons-material/Logout";

import SessionFail from "../../components/SessionFail";

import AccountForm from "./components/AccountForm";

const drawerWidth = 230;

function DashboardPage({ window, sessionActive, setSessionActive }) {
  const [keyMenu, setKeyMenu] = useState(0);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [openModalAccount, setOpenModalAccount] = useState(null);

  const handleModalToggleAccount = () => {
    setOpenModalAccount(!openModalAccount);
  };

  const dataMenu = [
    { icon: <HiOutlineChartBar />, label: "Fondo", link: "/dashboard/fondo" },
    {
      icon: <VscCircleLarge />,
      label: "Proximamente",
      // link: "/dashboard/black-circle",
    },
    { icon: <BsCoin />, label: "Proximamente", link: "/dashboard/fondo" },
    {
      icon: <IoCopyOutline />,
      label: "Proximamente",
      link: "/dashboard/fondo",
    },
    {
      icon: <TbCannabis />,
      label: "Proximamente",
      link: "/dashboard/fondo",
    },
    { icon: <BsCameraVideo />, label: "Proximamente", link: "/dashboard/fondo" },
  ];

  const handleDrawerToggle = () => setMobileOpen(!mobileOpen);

  const handleMenuClick = (key) => setKeyMenu(key);

  const drawer = (
    <div>
      <Toolbar>
        <Box m="auto" style={{ textAlign: "center", paddingTop: 10 }}>
          <img
            src={Logo}
            alt="Logo Portafolio Millonario"
            style={{ width: "50%", textAlign: "center" }}
          />
        </Box>
      </Toolbar>
      <List>
        {dataMenu.map((item, key) => (
          <ListItem
            key={item.label}
            disablePadding
            onClick={() => handleMenuClick(key)}
          >
            <Link
              to={item.link}
              style={{ textDecoration: "none", width: "100%" }}
            >
              <ListItemButton
                sx={{
                  backgroundColor: key === keyMenu ? "#202020" : null,
                  color: key === keyMenu ? "#EEEEEE" : "#303030",
                  mx: 1,
                  my: 0.5,
                  borderRadius: key === keyMenu ? "8px" : null,
                }}
              >
                <ListItemIcon
                  sx={{ color: key === keyMenu ? "#EEEEEE" : "#303030" }}
                >
                  {item.icon}
                </ListItemIcon>
                <ListItemText primary={item.label} />
              </ListItemButton>
            </Link>
          </ListItem>
        ))}
      </List>
    </div>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;
  const navigate = useNavigate();

  const logout = () => {
    Cookies.remove("jwt");
    Cookies.remove("id");
    setSessionActive(false);
    navigate("/login");
  };

  return sessionActive ? (
    <>

      <Modal
        open={!!openModalAccount}
        onClose={() => setOpenModalAccount(null)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <AccountForm setOpenModalAccount={setOpenModalAccount}/>
      </Modal>

      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <AppBar
          position="fixed"
          sx={{
            width: { sm: `calc(100% - ${drawerWidth}px)` },
            ml: { sm: `${drawerWidth}px` },
            backgroundColor: "#121212",
          }}
        >
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{
                mr: 2,
                display: { sm: "none" },
                backgroundColor: "#121212",
              }}
            >
              <MenuIcon />
            </IconButton>

            {/* {keyMenu === 0 && (
              <img
                src={LogoFondo}
                alt="Logo Fondo"
                style={{ width: "125px" }}
              />
            )} */}
            <Box sx={{ flexGrow: 1 }} />
            <IconButton color="inherit">
              <AccountCircle onClick={() => handleModalToggleAccount()} />
            </IconButton>
            <IconButton color="inherit" onClick={logout}>
              <LogoutIcon />
            </IconButton>
          </Toolbar>
        </AppBar>

        <Box
          component="nav"
          sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        >
          <Drawer
            container={container}
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{ keepMounted: true }}
            sx={{
              display: { xs: "block", sm: "none" },
              "& .MuiDrawer-paper": {
                width: drawerWidth,
                backgroundColor: "#121212", // Aquí el color negro
                backgroundImage: "none",
                zIndex: 99999,
              },
            }}
          >
            {drawer}
          </Drawer>

          <Drawer
            variant="permanent"
            sx={{
              display: { xs: "none", sm: "block" },
              "& .MuiDrawer-paper": { width: drawerWidth },
            }}
            open
          >
            {drawer}
          </Drawer>
        </Box>

        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 3,
            width: { sm: `calc(100% - ${drawerWidth}px)` },
          }}
        >
          <Toolbar />
          <Outlet />
        </Box>
      </Box>
    </>
  ) : (
    <SessionFail />
  );
}

DashboardPage.propTypes = {
  window: PropTypes.func,
};

export default DashboardPage;
